<script>
  import { _ as t } from "svelte-i18n";
  import { Icon } from "t2c-components";

  export let data;

  const unselectedColor = "#999";
  const selectedColor = "var(--accent)";
</script>

<div class="wrapper">
  <label class={`type ${data.type === "person" ? "selected" : ""}`}>
    <input
      type="radio"
      name="person"
      bind:group={data.type}
      value="person"
      on:change
    />
    <Icon icon="person" fill="currentColor" stroke="none" />
    <span>{$t("data.person")}</span>
  </label>

  <label class={`type ${data.type === "company" ? "selected" : ""}`}>
    <input
      type="radio"
      name="company"
      bind:group={data.type}
      value="company"
      on:change
    />
    <Icon icon="company" fill="currentColor" stroke="none" />
    <span>{$t("data.company")}</span>
  </label>

  <label class={`type ${data.type === "association" ? "selected" : ""}`}>
    <input
      type="radio"
      name="association"
      bind:group={data.type}
      value="association"
      on:change
    />
    <Icon icon="group" fill="currentColor" stroke="none" />
    <span>{$t("data.association")}</span>
  </label>
</div>

<style>
  .wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  @media only screen and (min-width: 600px) {
    .wrapper {
      flex-direction: row;
      flex-wrap: wrap;
    }
  }

  .type {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #999;
  }

  .type:hover {
    color: var(--accent);
  }

  .selected {
    color: var(--accent);
  }

  span {
    display: block;
    font-size: 18px;
    letter-spacing: 0.03rem;
    margin-left: 0.5rem;
  }

  @media only screen and (min-width: 600px) {
    span {
      font-size: 20px;
    }
  }

  input {
    display: none;
  }
</style>
